<div class="modal-contactenos">
    <div class="contactenos-header">
        <button type="btn-close" (click)="onNoClick()"><span class="icon icon-close"></span></button>
    </div>
    <h5 class="modal-title">
        Contáctanos
    </h5>

    <p>
        Si tienes algún comentario, sugerencia, pregunta o cualquier retroalimentación que quieras compartir con nosotros, por favor enviala a través de este formulario.

    </p>

    <form class="contactenos" [formGroup]="dataContact" (ngSubmit)="send()">
        <mat-form-field appearance="outline">
            <input matInput placeholder="Nombre/ razón social" formControlName="name">
            <mat-error *ngIf="(dataContact.get('name')?.touched  && dataContact.get('name')?.errors?.required) || (dataContact.get('name')?.errors?.required)">Por favor ingrese sus nombres</mat-error>
            <mat-error *ngIf="(dataContact.get('name')?.touched  && dataContact.get('name')?.errors?.pattern)">El campo es alfabético</mat-error>
        </mat-form-field>
        <br>
        <mat-form-field appearance="outline">
            <input matInput placeholder="Correo electrónico" formControlName="email" required>
            <mat-error *ngIf="(dataContact.get('email')?.errors?.email || dataContact.get('email')?.errors?.pattern)">El email no es válido</mat-error>
            <mat-error *ngIf="(dataContact.get('email')?.touched && dataContact.get('email')?.errors?.required) || (dataContact.get('email')?.errors?.required)">Por favor ingrese su correo electrónico</mat-error>

        </mat-form-field>
        <br>
        <mat-form-field appearance="outline">

            <textarea matInput placeholder="Mensaje" formControlName="message"></textarea>
            <mat-error *ngIf="(dataContact.get('message')?.touched  && dataContact.get('message')?.errors?.required) || (dataContact.get('message')?.errors?.required)">Por favor ingrese una descripción</mat-error>
            <mat-error *ngIf="(dataContact.get('message')?.touched  && dataContact.get('message')?.errors?.pattern)">El campo es alfabético</mat-error>
        </mat-form-field>
        <mat-checkbox class="example-margin" formControlName="bcc" name="BBC">Enviar una copia a mi correo electrónico</mat-checkbox>
        <div class="form-group text-xs-center">
            <re-captcha #captchaRef="reCaptcha" class="g-recaptcha" formControlName="recaptcha" siteKey="{{RE_CAPTCHA_KEY}}" (resolved)="$event && resolved($event)"></re-captcha>
        </div>
        <p class="terms">
            Al hacer clic en el siguiente botón, declaras que has leído los
            <a href="https://www.ciencuadras.com/terminos-y-condiciones" rel="nofollow" target="blank">Términos y condiciones</a>, y el <a href="https://www.ciencuadras.com/politicas-de-datos-personales" rel="nofollow" target="blank">aviso de privacidad</a>            del portal, y que aceptas en su totalidad.
        </p>
        <button [disabled]="dataContact.invalid && buttonDisabled?true:false" class="button secondary  rounded mb-base text-center block" type="submit">Enviar</button>
    </form>

</div>